var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "white",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.332 5.4974V7.51406C18.332 8.83073 17.4987 9.66406 16.182 9.66406H13.332V3.83906C13.332 2.91406 14.0904 2.16406 15.0154 2.16406C15.9237 2.1724 16.757 2.53906 17.357 3.13906C17.957 3.7474 18.332 4.58073 18.332 5.4974Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 6.33073V17.9974C1.66797 18.6891 2.45128 19.0807 3.00128 18.6641L4.4263 17.5974C4.75963 17.3474 5.22631 17.3807 5.52631 17.6807L6.90962 19.0724C7.23462 19.3974 7.76799 19.3974 8.09299 19.0724L9.49298 17.6724C9.78465 17.3807 10.2513 17.3474 10.5763 17.5974L12.0013 18.6641C12.5513 19.0724 13.3346 18.6807 13.3346 17.9974V3.83073C13.3346 2.91406 14.0846 2.16406 15.0013 2.16406H5.83464H5.0013C2.5013 2.16406 1.66797 3.65573 1.66797 5.4974V6.33073Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8H10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 11.3359H9.375",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperScroll);
export default __webpack_public_path__ + "static/media/paper-scroll.13f9a934602754338a9cdb3c859694ed.svg";
export { ForwardRef as ReactComponent };